import { Lightbulb, ListOrdered, Scale, Search, Sparkles } from 'lucide-react';
import { getLexCounselSuggestions, type LexCounselSuggestion } from '../../lib/lexCounselSuggestions';
import { useLexCounselStore } from '../../store/lexCounselStore';
import { PANEL_CAPTION, COUNSEL_CHIP } from './lexCounselPanelUi';

const CHIP_ICONS = [ListOrdered, Sparkles, Search, Lightbulb, Sparkles, Search];

type Props = {
  onSelect: (item: LexCounselSuggestion) => void;
  disabled?: boolean;
  variant?: 'list' | 'chips';
};

export default function LexCounselSuggestions({
  onSelect,
  disabled,
  variant = 'chips',
}: Props) {
  const workspace = useLexCounselStore((s) => s.workspace);
  const editorCounselMode = useLexCounselStore((s) => s.editorCounselMode);
  const hasFilingReview = useLexCounselStore((s) => Boolean(s.filingReviewReport));
  const suggestions = getLexCounselSuggestions(workspace, editorCounselMode, {
    hasFilingReview,
  }).slice(0, 4);

  if (!suggestions.length) return null;

  if (variant === 'list') {
    return (
      <div className="px-3 pt-2 pb-1 max-h-[28vh] overflow-y-auto">
        {suggestions.map((item) => (
          <button
            key={item.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(item)}
            className={`w-full flex items-start gap-2 py-2 px-2 -mx-2 rounded-xl text-left hover:bg-[var(--counsel-hover-subtle)] transition-colors disabled:opacity-50 ${PANEL_CAPTION}`}
          >
            {item.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {suggestions.map((item, index) => {
        const Icon = item.primary ? Scale : CHIP_ICONS[index % CHIP_ICONS.length];
        return (
          <button
            key={item.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(item)}
            className={`inline-flex w-fit max-w-full items-center gap-1.5 rounded-full ${COUNSEL_CHIP} px-3 py-1.5 text-left transition-colors disabled:opacity-50 ${PANEL_CAPTION} ${
              item.primary
                ? 'border border-[var(--counsel-accent,var(--counsel-border))] bg-[var(--counsel-active-bg)] font-medium'
                : ''
            }`}
          >
            <Icon className="h-3.5 w-3.5 shrink-0 text-[var(--counsel-text-muted)]" aria-hidden />
            <span className="truncate">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
